// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/edit-inventory.less
// module id = 3484
// module chunks = 0